import { Link } from "react-router-dom";
import { Pill } from "@/components/admin/AdminUI";
import { BAN_CATEGORIES } from "@/lib/constants";
import { formatDate } from "@/lib/format";

// GET /admin/users/{id} -> active_bans: every ACTIVE phone/device ban matching this person's phone or devices.
export default function ActiveBans({ items }) {
  if (!items?.length) return <p className="cw-muted text-sm" data-testid="user-active-bans-empty">No active bans match this person’s phone or devices.</p>;
  return (
    <ul className="divide-y divide-border" data-testid="user-active-bans">
      {items.map((b, i) => (
        <li key={`${b.type}-${b.value_masked}-${i}`} className="flex flex-wrap items-start justify-between gap-3 py-3 text-sm" data-testid={`user-active-ban-${i}`}>
          <div className="min-w-0">
            <p><span className="capitalize font-medium">{b.type}</span> · <span className="cw-soft break-all font-mono text-xs" data-testid={`user-active-ban-value-${i}`}>{b.value_masked}</span></p>
            <p className="cw-muted mt-1 text-xs">
              {[b.category && (BAN_CATEGORIES[b.category] || b.category), b.reason !== b.category && b.reason, b.created_by && `by admin ${b.created_by}`, formatDate(b.created_at)].filter(Boolean).join(" · ")}
            </p>
            {b.ban_case_id && <p className="cw-muted mt-1 font-mono text-xs" data-testid={`user-active-ban-case-${i}`}>Case {b.ban_case_id}</p>}
          </div>
          {b.same_user ? <Pill tone="error" data-testid={`user-active-ban-source-${i}`}>This account</Pill> : (
            <span className="flex flex-col items-end gap-1">
              <Pill tone="warning" data-testid={`user-active-ban-source-${i}`}>From another account</Pill>
              {b.banned_user_id && <Link to={`/admin/users/${b.banned_user_id}`} className="font-mono text-xs underline-offset-2 hover:underline" data-testid={`user-active-ban-link-${i}`}>{b.banned_user_id}</Link>}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}
